import { render, staticRenderFns } from "./_tnc.vue?vue&type=template&id=4454429d&lang=pug&"
import script from "./_tnc.vue?vue&type=script&lang=js&"
export * from "./_tnc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports